<template>
  <div class="pages">
    <!-- 车辆属性信息 -->
    <car-attribute-list ref="carAttributeList" :carAttributeFeeConfig="carAttributeFeeConfig" style="margin-bottom: 40px;" :car-type-id.sync="carTypeId" :listCurrent.sync="listCurrent" :childrenCurrent.sync="childrenCurrent"/>
    <!-- 里程费 -->
    <mileage-fee ref="mileageFee" :carAttributeFeeConfig="carAttributeFeeConfig" style="margin-bottom: 24px;" v-if="formatCarConfig() && isSystemQuotation==='system'" />
    <!-- 装卸搬运费计算规则 -->
    <loading-unloading-fee ref="loadingUnloadingFee" :carAttributeFeeConfig="carAttributeFeeConfig" style="margin-bottom: 24px;" v-if="carAttributeFeeConfig.bulkCargoFeeInfo" />
    <!-- 二次费用 -->
    <secondary-fee ref="secondaryFee" :carAttributeFeeConfig="currentCarAttributeFeeConfig.loadUnloadWaitFeeRule" style="margin-bottom: 24px;" v-if="currentCarAttributeFeeConfig.loadUnloadWaitFeeRule"/>
    <!-- 发票费用 -->
    <invoice-fee ref="invoiceFee" :carAttributeFeeConfig="invoiceFeeInfo" style="margin-bottom: 24px;" v-if="invoiceFeeInfo" />
    <!-- 其他服务费 -->
    <other-fee ref="otherFee" :carAttributeFeeConfig="carAttributeFeeConfig" />
    <!-- 预览图片 -->
    <image-preview ref="imagePreview" />
    <car-attribute-details-popup ref="carAttributeDetailsPopup" />
  </div>
</template>

<script>
import { Toast } from "vant";
import { getAutoCarAttributeFeeConfig,getDictAppInvoice } from "@/api/beecargo/autoCarFeeRules/index.js";
import carAttributeList from "@/view/beecargo/autoCarFeeRules/components/car-attribute-list.vue";
import mileageFee from "@/view/beecargo/autoCarFeeRules/components/mileage-fee.vue";
import loadingUnloadingFee from "@/view/beecargo/autoCarFeeRules/components/loading-unloading-fee.vue";
import secondaryFee from "@/view/beecargo/autoCarFeeRules/components/secondary-fee.vue";
import invoiceFee from "@/view/beecargo/autoCarFeeRules/components/invoice-fee.vue";
import otherFee from "@/view/beecargo/autoCarFeeRules/components/other-fee.vue";
import imagePreview from "@/view/beecargo/autoCarFeeRules/components/image-preview.vue";
import carAttributeDetailsPopup from "@/view/beecargo/autoCarFeeRules/components/car-attribute-details-popup.vue";
export default {
  components:{ 
    carAttributeList ,
    mileageFee ,
    loadingUnloadingFee ,
    secondaryFee ,
    invoiceFee ,
    otherFee ,
    imagePreview ,
    carAttributeDetailsPopup ,
    [Toast.name]:Toast
  },
  data(){
    return {
      carTypeId:null,
      carAttributeFeeConfig:{},
      isSystemQuotation:'system',
      listCurrent:0,
      childrenCurrent:0,
      invoiceFeeInfo:null
    }
  },
  watch:{
    carTypeId:{
      handler(val){
        this.formatCarConfig();
      }
    }
  },
  computed:{
    currentCarAttributeFeeConfig(){
      return this.carAttributeFeeConfig[this.listCurrent].children[this.childrenCurrent].feeConfig;
    }
  },
  provide(){
    return {
      imagePreview: options => this.$refs["imagePreview"].show(options),
      carAttributeDetailsPopup : options => this.$refs["carAttributeDetailsPopup"].show(options)
    }
  },
  created(){
    this.getCarAttributeFeeConfig();
    this.getAppInvoice();
  },
  methods:{
    getCarAttributeFeeConfig(){
      this.$toast({
        type:"loading",
        forbidClick:true,
        duration:0,
        message:"加载中"
      });
      return getAutoCarAttributeFeeConfig().then(({ data }) => {
        if(!data) return false;
        // 过滤掉没有子元素的项
				data = data && data.filter(item => 
				  item.children && item.children.length > 0
				);
        this.carAttributeFeeConfig = data;
      }).finally(()=>Toast.clear())
    },
    getAppInvoice(){
      getDictAppInvoice().then(res=>{
        console.log('res.data.find(item=>item.dictType===: ', res.data.find(item=>item.dictLabel==='VAT_ELECTRONIC_INVOICE'));

        this.invoiceFeeInfo = {
          vatElectronicScale:res.data.find(item=>item.dictLabel==='VAT_ELECTRONIC_INVOICE')?res.data.find(item=>item.dictLabel==='VAT_ELECTRONIC_INVOICE').dictValue:0,
          vatSpecialScale:res.data.find(item=>item.dictLabel==='VAT_SPECIAL_INVOICE')?res.data.find(item=>item.dictLabel==='VAT_SPECIAL_INVOICE').dictValue:0
        };
      })
    },
    formatCarConfig(){
      if(!this.carAttributeFeeConfig || this.carAttributeFeeConfig.length === 0)return false;
      this.$set(this.carAttributeFeeConfig, 'mileages', this.carAttributeFeeConfig[this.listCurrent].children[this.childrenCurrent].feeConfig.mileageChargingRule)
      return this.carAttributeFeeConfig[this.listCurrent].children[this.childrenCurrent].feeConfig.mileageChargingRule;
    }
  }
}
</script>

<style scoped lang="scss">
  .pages {
    background-color: #FFF;
    padding-bottom: 46px;
  }
  ::v-deep .component {
    padding: 0 12px;
    .component-title {
      font-size: 16px;
      color: #EC892E;
      line-height: 32px;
      padding-left: 7px;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 8px;
        top: 8px;
        z-index: 1;
        width: 3px;
        border-radius: 1px;
        background-color: #EC892E;
      }
    }
    .flex-sb {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
</style>